import { Component, OnInit } from '@angular/core';
import { AbstractPage } from '../AbstractPage';
import { LoadingController, ModalController, NavController, NavParams } from '@ionic/angular';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RilevazionePresenzeService } from '../services/rilevazione-presenze-service';
import { Rilevazione } from '../models/rilevazione-presenze/rilevazione';
import { Presenza } from '../models/rilevazione-presenze/presenza';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from '../services/user-service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-copia-presenze',
    templateUrl: './copia-presenze.page.html',
    styleUrls: ['./copia-presenze.page.scss'],
    standalone: false
})
  export class CopiaPresenzePage extends AbstractPage implements OnInit {

    rilevazione: Rilevazione;
    rilevazione_: Rilevazione;
    rilCorrente: Rilevazione;
    presenze: Presenza[];
    form: FormGroup;
    form_: FormGroup;
    presenzeCopiate = [];
    raggruppamento = 'daRil';
    presenzeCorrenti: Presenza[];
    aRil = false;
    delRil = false;
    sameRil = false;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public router: Router,
        public modalCtrl: ModalController,
        public rilevazionePresenzeService: RilevazionePresenzeService,
        private formBuilder: FormBuilder,
        public userService: UserService,
        public loadingCtrl: LoadingController,
        public translateService: TranslateService
    ) {
        super(navCtrl, router);

        this.rilCorrente = this.navParams.get('rilevazione');
        this.presenzeCorrenti = this.navParams.get('presenze');

        this.form = this.formBuilder.group({
            presenti: [],
            all: []
        });

        this.form_ = this.formBuilder.group({
          presenti: [],
          all: []
      });
    }

    ngOnInit(): void {
        console.log('ngOnInit CopiaPresenzePage');
    }

    cancel() {
        this.modalCtrl.dismiss();
    }

    elimina() {
      if (this.delRil === false) {
        this.delRil = true;
      } else {
        this.delRil = false;
      }
    }

    async selezionaRilevazione(rilevazione) {
      if (!rilevazione) {
        this.rilevazione = null;
        this.rilevazione_ = null;
        return;
      }

      this.sameRil = false;
      if (this.raggruppamento === 'aRil') {
        this.rilevazione_ = rilevazione;
        this.aRil = true;
      } else {
        this.rilevazione = rilevazione;
        this.aRil = false;
      }
        if (this.rilevazione) {
          const loader = await this.loadingCtrl.create({
            message: this.translateService.instant('label.richiestaincorso')
          });
          loader.present();
          this.rilevazionePresenzeService.getPresenze(this.rilevazione).subscribe(presenzeResp => {
              this.presenze = presenzeResp;
                // if (this.presenze) {
                //     this.presenzeCopiate = [];
                //     this.form.controls['presenti'].setValue(true);
                //     this.form.controls['all'].setValue(true);
                //     // presenzeResp.forEach(pres => {
                //     //   this.presenzeCopiate.push(pres);
                //     // });
                // }
                console.log('this.presenze ', this.presenze);
                loader.dismiss();
            });


            if (rilevazione.iul === this.rilCorrente.iul) {
              this.sameRil = true;
            } else {
              this.sameRil = false;
            }
        } else {
          if (this.rilevazione_.iul === this.rilCorrente.iul) {
            this.sameRil = true;
          } else {
            this.sameRil = false;
          }
        }
    }

    cercaRilevazione(
        service: RilevazionePresenzeService,
        search: string
      ): Observable<any> {
        return service.cercaRilevazionePerIul(search);
    }

    aggiungiPresenza(presenza: Presenza) {
        console.log('presenza', this.form.controls['presenti'].value);
        if (this.rilevazione) {
          if (this.form.controls['presenti'].value) {
            const index = this.presenzeCopiate.indexOf(presenza);
            if (index < 0) {
              this.presenzeCopiate.push(presenza);
            }
          } else {
            const index = this.presenzeCopiate.indexOf(presenza);
            this.presenzeCopiate.splice(index, 1);
          }
        } else {
          if (this.form_.controls['presenti'].value) {
            const index = this.presenzeCopiate.indexOf(presenza);
            if (index < 0) {
              this.presenzeCopiate.push(presenza);
            }
          } else {
            const index = this.presenzeCopiate.indexOf(presenza);
            this.presenzeCopiate.splice(index, 1);
          }
        }

      }

      async conferma() {
        await this.modalCtrl.dismiss([this.presenzeCopiate, this.rilevazione_, this.aRil, this.rilCorrente, this.delRil]);
      }

      selectAll() {
        if (this.rilevazione) {
          if (this.form.controls['all'].value) {
            this.form.controls['presenti'].setValue(true);
            this.presenzeCopiate = [];
            this.presenze.forEach(presenza => {
              this.presenzeCopiate.push(presenza);
            });
          } else {
            this.form.controls['presenti'].setValue(false);
            this.presenzeCopiate = [];
          }
        } else {
          if (this.form_.controls['all'].value) {
            this.form_.controls['presenti'].setValue(true);
            this.presenzeCopiate = [];
            this.presenzeCorrenti.forEach(presenza => {
              this.presenzeCopiate.push(presenza);
            });
          } else {
            this.form_.controls['presenti'].setValue(false);
            this.presenzeCopiate = [];
          }
        }

      }

      resetData() {
        this.sameRil = false;
        this.rilevazione = null;
        this.rilevazione_ = null;
        this.presenzeCopiate = [];
      }
  }
  